import {LegacyRegulationWrapper} from '../legacy-regulation-wrapper'
import {IRegulationComponents} from "../regulation-components.interface";
import {GermanyRegulationComponents} from "./components/germany.regulation-components";
import {
  GermanyRealityCheckDialogComponent
} from "../../../components/reality-check/germany/germany.reality-check-dialog.component";
import {DISPLAY_MESSAGE_IDS, DISPLAY_MESSAGE_NAMES} from "../../../../common/const/casinofied-analytics-consts";

export class GermanyRegulation extends LegacyRegulationWrapper {

  async logoutUser(): Promise<void> {
    await this.services.specificDialogs.showConfirmLugasCoolingOffLogout({
      onAccept: async () => super.logoutUser(),
      onReject: async () => {},
    });
  }

  get components(): IRegulationComponents {
    return new GermanyRegulationComponents(this.services);
  }

  async showRealityCheckMessage(): Promise<void> {
    const gameRunner = await this.services.gameRunner;
    if (!gameRunner.shouldShowRealityCheckMessage) {
      return;
    }

    const businessCorrelationId = this.services.tools.getGuid();

    let totalNetLoss = 0;

    try {
      totalNetLoss = (await this.services.api.userController.getRealityCheckData()).TotalNetLoss;
    } catch (err) {
      this.services.logger.error('Failed to get germany reality check data', err);
    }

    return new Promise<void>(resolve => {

      this.services.casinofiedAnalytics.messageDisplay({
        displayMessageID: DISPLAY_MESSAGE_IDS.realityCheckGermany,
        displayMessageName: DISPLAY_MESSAGE_NAMES.REALITY_CHECK_GERMANY_MESSAGE_NAME,
        businessCorrelationID: businessCorrelationId
      });


      this.services.sdk.eventsTrigger.realityCheckOpen();

      this.services.dialog.showModal((dialogHandler) => (
          <GermanyRealityCheckDialogComponent dialogHandler={dialogHandler}
                                              businessCorrelationId={businessCorrelationId}
                                              totalNetLoss={totalNetLoss}/>), {
        title: this.services.translation.translate('REALITY_CHECK_DIALOG_TITLE'),
        hideCloseButton: true,
        showPopupAboveSecondWebViewHybrid: true,
        disableFullscreenMobile: true,
        forceCentralization: true,
        isHighPriority: true,
        onClosed: () => {
          this.services.sdk.eventsTrigger.realityCheckClosed();
          resolve();
        }
      })
    })
  }
}